import { clientEnv } from "./client-env";

const localHostnames = new Set(["localhost", "127.0.0.1"]);

export function resolveLocalAdminAuthMode(options: {
  isDev: boolean;
  hostname?: string | null;
}): boolean {
  if (typeof options.hostname !== "string") {
    return options.isDev;
  }

  // Scope the Better Auth fallback to loopback hosts so dev servers exposed through lvh.me still exercise the Cloudflare Access boundary.
  return localHostnames.has(options.hostname);
}

export function isLocalAdminAuthMode(): boolean {
  if (typeof window === "undefined") {
    return resolveLocalAdminAuthMode({
      isDev: clientEnv.DEV,
    });
  }

  return resolveLocalAdminAuthMode({
    isDev: clientEnv.DEV,
    hostname: window.location.hostname,
  });
}
